import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './ComandaNoua.css';

const ComandaNoua = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [meniu, setMeniu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState('');
  const [observatii, setObservatii] = useState('');
  const [cos, setCos] = useState([]);
  const [success, setSuccess] = useState(false);

  const categorii = [
    { value: 'mic dejun', label: 'Mic Dejun', icon: '🥐' },
    { value: 'gustare dimineata', label: 'Gustare Dimineață', icon: '🍎' },
    { value: 'pranz', label: 'Prânz', icon: '🍲' },
    { value: 'gustare dupa-amiaza', label: 'Gustare După-Amiază', icon: '🍪' }
  ];

  useEffect(() => {
    loadMeniu();
    // Setează data implicită la ziua următoare
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    setData(tomorrow.toISOString().split('T')[0]);
  }, []);

  const loadMeniu = async () => {
    try {
      const response = await axios.get('/api/meniu?disponibil=true');
      setMeniu(response.data);
    } catch (error) {
      console.error('Eroare la încărcare meniu:', error);
    } finally {
      setLoading(false);
    }
  };

  const getMeniuByCategorie = (categorie) => {
    return meniu.filter(item => item.categorie === categorie);
  };

  const addToCos = (item) => {
    const existing = cos.find(c => c.meniu === item._id);
    if (existing) {
      setCos(cos.map(c => 
        c.meniu === item._id 
          ? { ...c, numarPortii: c.numarPortii + 1 }
          : c
      ));
    } else {
      setCos([...cos, {
        meniu: item._id,
        numeArticol: item.nume,
        categorie: item.categorie,
        pret: item.pret,
        numarPortii: 1
      }]);
    }
  };

  const updatePortii = (meniuId, numarPortii) => {
    if (numarPortii <= 0) {
      removeFromCos(meniuId);
    } else {
      setCos(cos.map(c => 
        c.meniu === meniuId 
          ? { ...c, numarPortii: parseInt(numarPortii) }
          : c
      ));
    }
  };

  const removeFromCos = (meniuId) => {
    setCos(cos.filter(c => c.meniu !== meniuId));
  };

  const getTotalPortii = () => {
    return cos.reduce((sum, item) => sum + item.numarPortii, 0);
  };

  const getTotalPret = () => {
    return cos.reduce((sum, item) => sum + (item.pret * item.numarPortii), 0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (cos.length === 0) {
      alert('Te rog adaugă cel puțin un articol în coș!');
      return;
    }

    setSubmitting(true);
    try {
      await axios.post('/api/comenzi', {
        data,
        items: cos,
        observatii
      });
      
      setSuccess(true);
      setTimeout(() => {
        navigate('/educatoare/comenzile-mele');
      }, 2000);
    } catch (error) {
      console.error('Eroare la plasare comandă:', error);
      alert('Eroare la plasare comandă. Te rog încearcă din nou.');
      setSubmitting(false);
    }
  };

  if (loading) return <div>Se încarcă...</div>;

  if (success) {
    return (
      <div className="success-screen">
        <div className="success-icon">✅</div>
        <h1>Comandă Plasată cu Succes!</h1>
        <p>Te redirectăm către comenzile tale...</p>
      </div>
    );
  }

  return (
    <div className="comanda-noua">
      <div className="page-header">
        <h1>Comandă Nouă</h1>
        <p>Creează o comandă pentru clasa ta</p>
      </div>

      <div className="comanda-container">
        <div className="meniu-section">
          <div className="card">
            <div className="form-group">
              <label>📅 Data Comenzii *</label>
              <input
                type="date"
                value={data}
                onChange={(e) => setData(e.target.value)}
                required
                min={new Date().toISOString().split('T')[0]}
              />
            </div>
          </div>

          {categorii.map(cat => {
            const items = getMeniuByCategorie(cat.value);
            if (items.length === 0) return null;

            return (
              <div key={cat.value} className="card categoria-section">
                <h3>{cat.icon} {cat.label}</h3>
                <div className="meniu-grid">
                  {items.map(item => (
                    <div key={item._id} className="meniu-card">
                      <div className="meniu-info">
                        <h4>{item.nume}</h4>
                        {item.descriere && <p className="descriere">{item.descriere}</p>}
                        {item.alergeni && item.alergeni.length > 0 && (
                          <p className="alergeni">
                            ⚠️ Alergeni: {item.alergeni.join(', ')}
                          </p>
                        )}
                        <p className="pret">{item.pret.toFixed(2)} lei/porție</p>
                      </div>
                      <button 
                        className="btn btn-primary btn-sm"
                        onClick={() => addToCos(item)}
                      >
                        + Adaugă
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="cos-section">
          <div className="card cos-card sticky">
            <h3>🛒 Coșul Comenzii</h3>
            
            {cos.length === 0 ? (
              <p className="cos-gol">Coșul este gol. Adaugă articole din meniu.</p>
            ) : (
              <>
                <div className="cos-items">
                  {cos.map(item => (
                    <div key={item.meniu} className="cos-item">
                      <div className="cos-item-info">
                        <strong>{item.numeArticol}</strong>
                        <span className="cos-item-pret">{item.pret.toFixed(2)} lei</span>
                      </div>
                      <div className="cos-item-actions">
                        <input
                          type="number"
                          min="1"
                          value={item.numarPortii}
                          onChange={(e) => updatePortii(item.meniu, e.target.value)}
                          className="portii-input"
                        />
                        <button
                          className="btn-remove"
                          onClick={() => removeFromCos(item.meniu)}
                          title="Elimină"
                        >
                          🗑️
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="cos-total">
                  <div className="total-row">
                    <span>Total Porții:</span>
                    <strong>{getTotalPortii()}</strong>
                  </div>
                  <div className="total-row total-pret">
                    <span>Total:</span>
                    <strong>{getTotalPret().toFixed(2)} lei</strong>
                  </div>
                </div>

                <div className="form-group">
                  <label>💬 Observații (opțional)</label>
                  <textarea
                    value={observatii}
                    onChange={(e) => setObservatii(e.target.value)}
                    placeholder="Ex: 2 copii alergici la lactate, 1 copil vegetarian..."
                    rows="4"
                  />
                </div>

                <button
                  className="btn btn-primary btn-block btn-large"
                  onClick={handleSubmit}
                  disabled={submitting}
                >
                  {submitting ? 'Se plasează comanda...' : '✓ Plasează Comanda'}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComandaNoua;
